import React, { Suspense } from 'react'
import { connect } from 'react-redux'

import Modal from '.'
import PopupModal from './PopupModal'
import Field from '../fields'
import { Dispatch } from 'redux'
// @ts-ignore
import { AppAction } from './your-app' // Import your app-specific action types here

const MODAL_ID = 'addEmarRoundTimingModal'

interface EmarRoundTiming {
  time: string
  title: string
  // Define other properties of the EmarRoundTiming object
}

interface EmarRoundTimingModalProps {
  isOpen: boolean
  fields: EmarRoundTiming
  setFormField: (data: any) => void // Replace 'any' with your form data type
  createItem: (data: any) => void // Replace 'any' with the expected data type
  setLoadedListItem: (list: string, item: any) => void // Replace 'any' with the expected data type
  showToast: (options: { title: string }) => void
  testId?: string
  // addForm: () => void;
}

const handleSubmit = (props: EmarRoundTimingModalProps) => {
  const { createItem, fields, setLoadedListItem, showToast } = props

  createItem({
    json: fields,
    onComplete: (resp: any) => {
      showToast({ title: 'Added a round timing' })
      setLoadedListItem('emar-round-timings', resp)
    },
    url: 'list/emar-round-timings'
  })
}

export const EmarRoundTimingModal: React.FC<EmarRoundTimingModalProps> = (
  props
) => {
  const { isOpen, setFormField, testId, ...formProps } = props

  if (!isOpen) return null

  return (
    <PopupModal
      confirmText="Add"
      buttonIcon="plus"
      buttonColour="success"
      list="Round Time"
      subtitle="You will see these when you add a medication"
      onConfirm={() => handleSubmit(props)}
      data-testid={
        testId ? `${testId}-round-timing-modal` : 'round-timing-modal'
      }
      {...formProps}
      type="create"
    >
      <div
        style={{ display: 'flex' }}
        data-testid={
          testId ? `${testId}-round-timing-fields` : 'round-timing-fields'
        }
      >
        <div style={{ marginBottom: 20, maxWidth: 116 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="time"
              label="Time"
              required
              layout="column"
              formId={MODAL_ID}
              type="time"
              values={formProps.fields}
            />
          </Suspense>
        </div>
        <div style={{ marginBottom: 20 }}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="title"
              label="Round Name"
              layout="column"
              maxLength={13}
              placeholder="Eg. morning"
              formId={MODAL_ID}
              type="text"
              values={formProps.fields}
            />
          </Suspense>
        </div>
      </div>
    </PopupModal>
  )
}

const mapDispatchToProps = (dispatch: Dispatch<AppAction>) => ({
  // addForm: () => dispatch(Actions.addForm({ formId: MODAL_ID }))
})

const wrappedModal = connect(null, mapDispatchToProps)(EmarRoundTimingModal)

export default Modal(wrappedModal, MODAL_ID)
